import { render, staticRenderFns } from "./SetOfCriteriaSave.vue?vue&type=template&id=f4fc72c2&scoped=true&"
import script from "./SetOfCriteriaSave.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaSave.vue?vue&type=script&lang=js&"
import style0 from "./SetOfCriteriaSave.vue?vue&type=style&index=0&id=f4fc72c2&prod&lang=scss&scoped=true&"
import style1 from "./SetOfCriteriaSave.vue?vue&type=style&index=1&id=f4fc72c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fc72c2",
  null
  
)

export default component.exports